export const bankInfo = {
  scotiabank: {
    bankName: 'Interbank',
    accountHolder: 'Alonso Arana ',
    accountNumber: '8983372314941',
    cci: '00389801337231494144',
  },
  yapePlin: {
    name: 'Yape/Plin',
    number: '970-070-369',
    accountHolder: 'Alonso Arana',
  },
};